import * as React from 'react';
import { useAuth } from 'src/modules/Auth/hooks/useAuth';
import SidebarLink from 'src/modules/Routing/Sidebar/SidebarLink/SidebarLink';
import { ICase } from 'src/share/types/case/case';
import Routes from 'src/modules/Routing/routes';
import { useRoutes } from 'src/modules/Routing/hooks/routes/useRoutes';

interface ICaseSideBar {
  caseId: string | undefined;
  loading: boolean | undefined;
  isCasesView: boolean | null;
  caseData: ICase | undefined;
  hideMobileSidebar: () => void;
  url: string;
  count: {
    open: number;
    closed: number;
    restricted: number;
    all: number;
  }
}

const CaseSidebarLinks = (props: ICaseSideBar) => {
  const [auth] = useAuth();
  const [routes] = useRoutes();
  const loading = !props.loading && props.isCasesView !== null;
  return (
    loading && !props.isCasesView && props.caseId ?
      <>
        <SidebarLink userType={auth.userType} routes={routes} onClick={props.hideMobileSidebar} to={Routes.CASECHILDREN} filterPath={`/${props.caseId}`} label='Children' />
        <SidebarLink userType={auth.userType} routes={routes} onClick={props.hideMobileSidebar} to={Routes.CASEINFO} filterPath={`/${props.caseId}`} label='Case Info' />
        <SidebarLink userType={auth.userType} routes={routes} onClick={props.hideMobileSidebar} to={Routes.CASECOMPANIONS} filterPath={`/${props.caseId}`} label='Companions' />
        {
          props.caseData && props.caseData.status === "open" ?
            <>
              <SidebarLink userType={auth.userType} routes={routes} onClick={props.hideMobileSidebar} to={Routes.CASEALERTS} filterPath={`/${props.caseId}`} label='Alerts' />
              <SidebarLink userType={auth.userType} routes={routes} onClick={props.hideMobileSidebar} to={Routes.CASEMATCHES} filterPath={`/${props.caseId}`} label='Matches' />
              <SidebarLink userType={auth.userType} routes={routes} onClick={props.hideMobileSidebar} to={Routes.CASEPOSTER} filterPath={`/${props.caseId}`} label='Poster' />
              <SidebarLink userType={auth.userType} routes={routes} onClick={props.hideMobileSidebar} to={Routes.TRANSFERCASE} filterPath={`/${props.caseId}`} label='Cross-border' />
            </> : null
        }
      </>
      : loading && props.isCasesView ?
        <>
          <SidebarLink userType={auth.userType} routes={routes} to={Routes.CASEDEFAULT} filterPath={'/view/open'} isActive={props.url === Routes.CASEDEFAULT || props.url === '`/cases/view/open`'} label='Open cases' counter={props.count.open} />
          <SidebarLink userType={auth.userType} routes={routes} to={Routes.CASEDEFAULT} filterPath={'/view/restricted'} label='Restricted from public view' counter={props.count.restricted} />
          <SidebarLink userType={auth.userType} routes={routes} to={Routes.CASEDEFAULT} filterPath={'/view/all'} label='All cases' counter={props.count.all} />
          <SidebarLink userType={auth.userType} routes={routes} to={Routes.CASEDEFAULT} filterPath={'/view/closed'} label='Closed cases' counter={props.count.closed} />
          <div className="notification-links">
            <SidebarLink userType={auth.userType} routes={routes} to={Routes.ADD} label='Add new case' />
          </div>
        </> : null
  )
}

export default CaseSidebarLinks;
